import { isDamaged } from "@redotech/redo-return-core-common/return-flow/condition-predicates";
import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import type { DraftReturn } from "@redotech/redo-return-operations-common/draft-return/draft-return";

export function isLostOrStolenClaim({
  returnType,
  returnProducts,
}: {
  returnType: string | null | undefined;
  returnProducts: readonly { damaged: boolean }[];
}): boolean {
  if (returnType !== ReturnTypeEnum.CLAIM) {
    return false;
  }
  return returnProducts.every((product) => !product.damaged);
}

export function isLostOrStolenDraftClaim(
  draftReturn: Pick<DraftReturn, "returnType" | "pendingReturnItems">,
): boolean {
  return isLostOrStolenClaim({
    returnType: draftReturn.returnType,
    returnProducts: draftReturn.pendingReturnItems.map((pendingReturnItem) => ({
      damaged: isDamaged({
        returnReason: pendingReturnItem.returnReason,
        aiDamaged: !!pendingReturnItem.aiDamaged,
        isAiReason: !!pendingReturnItem.aiReturnReasonsThreadId,
      }),
    })),
  });
}
